import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
const routes = {
  calculator: () => 'calculator'
}
@Injectable({
  providedIn: 'root'
})
export class CalculatorService {

  constructor(private apiService: ApiService) { }

  getUnitedInches(mouldingInch: number, mouldingWidth: number): Observable<any> {
    return this.apiService.get(`${routes.calculator()}/GetUnitedInches/${mouldingInch}/${mouldingWidth}`);
  }
}
